
<template>

    <div id="responsiveSlide" :class="tag">

        <div class="responsiveSlide-app-btn responsiveSlide-btn-back" @click="btnBack"><i class="icon1-chevron-left"></i></div>
        <div class="responsiveSlide-app-btn responsiveSlide-btn-next" @click="btnNext"><i class="icon1-chevron-right"></i></div>

        <div class="reposnive-slider-shadow-left"><div class="shadow-left"></div></div>
        <div class="reposnive-slider-shadow-right"><div class="shadow-right"></div></div>

         <h1 class="responsiveSlide-title">{{title}}</h1>

        <div class="responsiveSlide-content">

            <v-touch class="responsiveSlide-app" :class="{ twoLines: getWidth25 }" @panmove="panmoveApp" @panstart="panstartApp" @panend="panendApp">

                <v-touch v-if="hasTitleSlot && hasBack" class="app-item on-back" @tap="$emit('on-back')">
                    <slot name="title"></slot>
                </v-touch>
                
                <v-touch class="app-item" v-for="(item, index) in list" :key="index" @tap="$emit('on-tap', index, item)">
                    <slot name="list" :item="item" :index="index"></slot>
                </v-touch>
                
            </v-touch>
        
        </div>
        
    </div>

</template>


<script>


export default {

    props: ['list', 'tag', 'hasBack', 'title'],

    data(){
        return {
            translateXInit: 0,
        }
    },
    mounted: function () {
        
        const _this = this

        this.getNextBack()

        $(`.${this.tag} .responsiveSlide-app`).on("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd", function(){ 

            _this.getNextBack()

        })

        if( $('.prod').length == 0 ){

            $('#responsiveSlide.cat').addClass('one')
            $('.bar-black').hide()

        }else{

            $('#responsiveSlide.cat').removeClass('one')
            $('.bar-black').show()
            
        }




    },
    updated: function(){
        
        if( $('.prod').length == 0 ){

            $('#responsiveSlide.cat').addClass('one')
            $('.bar-black').hide()

        }else{

            $('#responsiveSlide.cat').removeClass('one')
            $('.bar-black').show()
            
        }

        const elmApp = document.querySelector(`.${this.tag} .responsiveSlide-app`)

        this.translateXInit = getComputedTranslateXY( elmApp )[0] || 0

        elmApp.style.transition = '0.1s ease-in-out'
        elmApp.style.transform = 'translateX(0px)'

        $(`.${this.tag} .reposnive-slider-shadow-left`).hide()
        $(`.${this.tag} .responsiveSlide-btn-back`).hide()

        this.getNextBack()
        

    },
    computed: {
        hasTitleSlot () {
            return !!this.$slots['title']
        },
        getWidth25() {

            if(!this.list || this.list.length < 8) return false

            return true

        },
    },
    methods: {
        twoLines() {

            if(!this.list || this.list.length < 8) return false

            return true

        },
        getListOneLine: function(){

            if( this.twoLines() == false ) return this.list.length

            if( isOdd(this.list.length) ){

                return Math.ceil(this.list.length / 2)

            }else{

                return this.list.length / 2

            }

        },
        elmxPage: function(){
       
            if(window.innerWidth <= 370) { 
                return 2
            }else if(window.innerWidth <= 570) { 
                return 3
            }else{
                return 4
            }

        },
        getTranslateExact: function(translateX, elmLength){

            let newArray = []
            for (let index = 0; index < (elmLength - (this.elmxPage() -1) ); index++) {

                newArray.push( translateX * index )
                
            }

            if(!newArray || newArray.length == 1){

                newArray.push(translateX)

            }
        

            return newArray

        },
        // detecta cuando se tienen que esconder las flechas
        getNextBack: function(){

            const elmApp = document.querySelector(`.${this.tag} .responsiveSlide-app`)

            const sliderLoop = document.querySelector(`.${this.tag} .app-item`)

            const computedTranslateXY = getComputedTranslateXY( elmApp )[0] || 0

            const translateX = computedTranslateXY - sliderLoop.offsetWidth

            const translateExactArray = this.getTranslateExact(sliderLoop.offsetWidth, this.getListOneLine() )

            const translateExact = closest(translateX*-1, translateExactArray )

            if( computedTranslateXY >= (sliderLoop.offsetWidth *-1 ) /2 ){
                $(`.${this.tag} .reposnive-slider-shadow-left`).hide()
                $(`.${this.tag} .responsiveSlide-btn-back`).hide()
            }else{
                $(`.${this.tag} .reposnive-slider-shadow-left`).show()
                $(`.${this.tag} .responsiveSlide-btn-back`).show()
            }

            if(!translateExact || translateExact <= computedTranslateXY *-1 ){
                $(`.${this.tag} .reposnive-slider-shadow-right`).hide()
                $(`.${this.tag} .responsiveSlide-btn-next`).hide()
            }else{
                $(`.${this.tag} .reposnive-slider-shadow-right`).show()
                $(`.${this.tag} .responsiveSlide-btn-next`).show()
            }
    
        },
        panmoveApp: function(e){

            const elmApp = document.querySelector(`.${this.tag} .responsiveSlide-app`)
        
            const translateX = this.translateXInit + e.deltaX

            elmApp.style.transform = `translateX(${translateX}px)`

            this.getNextBack()
          
        },
        panstartApp: function(e){
            
            const elmApp = document.querySelector(`.${this.tag} .responsiveSlide-app`)
            
            elmApp.style.transition = 'inehirt'

            this.translateXInit = getComputedTranslateXY( elmApp )[0] || 0

        },
        panendApp: function(e){
 
            const elmApp = document.querySelector(`.${this.tag} .responsiveSlide-app`)
            const size = elmApp.offsetWidth
            
            this.translateXInit = getComputedTranslateXY( elmApp )[0]

            let appitemSize = 0

            $(`.${this.tag} .app-item`).each(function(){
                appitemSize = appitemSize + $(this).outerWidth(true)
            })

            if(this.list && this.list.length > 8){ 
                appitemSize = appitemSize / 2 
                if( isOdd(this.list.length) ){
                    appitemSize = appitemSize + ( $($(`.${this.tag} .app-item`)[0]).outerWidth(true) / 2 )
                }
            }

            if(this.translateXInit > 0){ 
                elmApp.style.transition = '0.3s ease-in-out'
                elmApp.style.transform = 'translateX(0px)'
            }else if(size > appitemSize){
                elmApp.style.transition = '0.3s ease-in-out'
                elmApp.style.transform = `translateX(0px)`
            }else if( (this.translateXInit *-1) > ((( appitemSize / size ) -1 ) * size ) ){
                elmApp.style.transition = '0.3s ease-in-out'
                elmApp.style.transform = `translateX(${ ((( appitemSize / size ) -1 ) * size ) *-1 }px)`
            }else{

                // const sliderLoop = document.querySelector(`.${this.tag} .app-item`)

                // const translateExactArray = this.getTranslateExact(sliderLoop.offsetWidth, this.getListOneLine() )

                // this.translateXInit = getComputedTranslateXY( elmApp )[0] || 0

                // const translateExact = closest(this.translateXInit *-1, translateExactArray )

                // elmApp.style.transition = '0.3s ease-in-out'
                // elmApp.style.transform = `translateX( ${ translateExact *-1 }px)`

            }

        },

        btnNext: function(){
            
            const elmApp = document.querySelector(`.${this.tag} .responsiveSlide-app`)
            const sliderLoop = document.querySelector(`.${this.tag} .app-item`)

            this.translateXInit = getComputedTranslateXY( elmApp )[0] || 0
            const translateX = this.translateXInit - sliderLoop.offsetWidth

                        // console.log('btnNext', sliderLoop.offsetWidth, sliderLoop.offsetWidth, sliderLoop.width, sliderLoop.scrollWidth )

            const translateExactArray = this.getTranslateExact(sliderLoop.offsetWidth, this.getListOneLine() )

            let translateExact = closest(translateX*-1, translateExactArray )

            if( translateExactArray[translateExactArray.length-1] == translateExact ){
                $(`.${this.tag} .reposnive-slider-shadow-right`).hide()
                $(`.${this.tag} .responsiveSlide-btn-next`).hide()
                translateExact = translateExact + 24
            }

            if( translateExact != 0){
                $(`.${this.tag} .reposnive-slider-shadow-left`).show()
                $(`.${this.tag} .responsiveSlide-btn-back`).show()
            }

            elmApp.style.transition = '0.3s ease-in-out'
            elmApp.style.transform = `translateX( ${ translateExact *-1 }px)`

        },

        btnBack: function(){
            
            const elmApp = document.querySelector(`.${this.tag} .responsiveSlide-app`)
            const sliderLoop = document.querySelector(`.${this.tag} .app-item`)

            this.translateXInit = getComputedTranslateXY( elmApp )[0] || 0
            const translateX = this.translateXInit + sliderLoop.offsetWidth

            const translateExactArray = this.getTranslateExact(sliderLoop.offsetWidth, this.getListOneLine() )

            const translateExact = closest(translateX*-1, translateExactArray )

            if( translateExactArray[translateExactArray.length-1] != translateExact ){
                $(`.${this.tag} .reposnive-slider-shadow-right`).show()
                $(`.${this.tag} .responsiveSlide-btn-next`).show()
            }

            if( translateExact == 0){
                $(`.${this.tag} .reposnive-slider-shadow-left`).hide()
                $(`.${this.tag} .responsiveSlide-btn-back`).hide()
            }

            elmApp.style.transition = '0.3s ease-in-out'
            elmApp.style.transform = `translateX(${ translateExact *-1 }px)`


        }

    }
}


function isOdd(num) { return num % 2;}

function getComputedTranslateXY(obj){
	const transArr = [];
    if(!window.getComputedStyle) return;
    const style = getComputedStyle(obj),
        transform = style.transform || style.webkitTransform || style.mozTransform;
    let mat = transform.match(/^matrix3d\((.+)\)$/);    
    if(mat) return parseFloat(mat[1].split(', ')[13]);
    mat = transform.match(/^matrix\((.+)\)$/);
    mat ? transArr.push(parseFloat(mat[1].split(', ')[4])) : 0;
    mat ? transArr.push(parseFloat(mat[1].split(', ')[5])) : 0;
    return transArr;
}

function closest (num, arr) {
    var curr = arr[0];
    var diff = Math.abs (num - curr);
    for (var val = 0; val < arr.length; val++) {
        var newdiff = Math.abs (num - arr[val]);
        if (newdiff < diff) {
            diff = newdiff;
            curr = arr[val];
        }
    }
    return curr;
}


</script>



<style lang="scss">

// prod

    .responsiveSlide-title{
        font-size: 18px;
        text-transform: uppercase;
        text-align: center;
        margin-bottom: 20px;
    }


    #responsiveSlide.cat{

        border-radius: 40px 40px 0 0;

        border-right: solid 2px #ed3a5b;
        border-left: solid 2px #ed3a5b;
        border-top: solid 2px #ed3a5b;

        .responsiveSlide-title{
            background-image: linear-gradient(to right, #fc3740, #f3307a);
            color: transparent;
            -webkit-background-clip: text;
            background-clip: text;
        }

        .responsiveSlide-app-btn{
            background: linear-gradient(-180deg,#fc3740 20%,#f3307a 80%);
            top: calc(50% - 3.5px);
        }

    }

    #responsiveSlide.prod{

        border-radius: 0 0 40px 40px;

        border-right: solid 2px #00e0c5;
        border-left: solid 2px #00e0c5;
        border-bottom: solid 2px #00e0c5;
        
        .responsiveSlide-title{

            color: #00e0c5;

            background-image: linear-gradient(to right, #00e0c5, #4ee3fa);
            color: transparent;
            -webkit-background-clip: text;
            background-clip: text;

        }

        .responsiveSlide-app-btn{
            background: linear-gradient(-180deg,#0dfae3 20%,#4ee3fa 80%);
            top: calc(50% + 6.5px);
        }

    }

    #responsiveSlide.one{

        border-radius: 40px;
        border: solid 2px #ed3a5b;
        
    }

    .bar-black{
        width: 100%;
        background: #232d2f;
        height: 10px;
    }


    #responsiveSlide{
        color: #fff;

        padding: 24px;
        margin: 0 auto;
        position: relative;
        overflow: hidden;

     
        .reposnive-slider-shadow-left, .reposnive-slider-shadow-right{
            background: white;
            position: absolute;
            height: 100%;
            width: 1px;
            top: 0;
            z-index: 1;
            display: none;
        }

        .reposnive-slider-shadow-left{
            left: 0;
            box-shadow: -10px 0px 30px 50px #fff;
        }

        .reposnive-slider-shadow-right{
            right: 0;
            box-shadow: 10px 0px 30px 50px #fff;
        }

        .responsiveSlide-app-btn{

            position: absolute;
            display: flex;
            align-items: center;
            top: calc(50% - 12.5px);
            // left: 0;
            touch-action: none;

            background: blue;
            color: white;
            border-radius: 50%;
            height: 25px;
            width: 25px;
            display: flex;
            justify-content: center;
            align-items: center;
            line-height: 0;
            font-size: 19px;
            z-index: 2;
        
        }

        .responsiveSlide-btn-back{
            left: 5px;
        }

        .responsiveSlide-btn-next{
            right:5px;
        }

       

    }

    .responsiveSlide-content{
        width: 100%;
        overflow: hidden;

        .responsiveSlide-app:not(.twoLines){
             width: 100%;
            display: flex;
  
            .app-item{
                padding: 10px;
            }

            .width25{
                width: 25% !important;

                @media (max-width: 570px) { width: 33.33%; }
                @media (max-width: 370px) { width: 50%; }

            }

        }

        .responsiveSlide-app.twoLines{
            height: 300px;
            width: 100%;
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
  
            .app-item{
                height: 50%;
                width: 25%;

                @media (max-width: 570px) { width: 33.33%; }
                @media (max-width: 370px) { width: 50%; }

            }

            .width25{
                width: 25% !important;

                @media (max-width: 570px) { width: 33.33%; }
                @media (max-width: 370px) { width: 50%; }
                
            }

        }



    }

</style>



// WEBPACK FOOTER //
// src/components/responsiveSlide.vue